import React, { useEffect, useRef, useState } from "react";
import "./Header.css";

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const navbar = navbarRef.current;
    if (menuOpen) {
      document.body.classList.add("menu-open");
      document.body.style.overflow = "hidden";
      navbar.style.display = "block";
      setTimeout(() => {
        //navbar.style.opacity = 1;
      }, 10); // Kurze Verzögerung, um den Übergang zu ermöglichen
    } else {
      document.body.classList.remove("menu-open");
      document.body.style.overflow = "auto";
      //navbar.style.opacity = 0;
      setTimeout(() => {
        navbar.style.display = "none";
      }, 400);
    }
  }, [menuOpen]);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-6 col-lg-4 site-logo" data-aos="fade">
            <a className="logo-name" href="index.html">
              Casa Wadowski
            </a>
          </div>
          <div className="col-6 col-lg-8">
            {/*<div*/}
            {/*    className={`site-menu-toggle ${menuOpen ? 'open' : ''}`}*/}
            {/*    onClick={handleMenuClick}*/}
            {/*    data-aos="fade"*/}
            {/*>*/}
            {/*    <span></span>*/}
            {/*    <span></span>*/}
            {/*    <span></span>*/}
            {/*</div>*/}
            {/* END menu-toggle */}

            <div
              className="site-navbar js-site-navbar"
              ref={navbarRef}
              style={{ display: menuOpen ? "block" : "none" }}
              //style={{ opacity: 0, transition: 'opacity 0.4s ease' }}
            >
              <nav role="navigation">
                <div className="container">
                  <div className="row full-height align-items-center">
                    <div className="col-md-6 mx-auto">
                      <ul className="list-unstyled menu">
                        <li className="active">
                          <a href="index.html">Home</a>
                        </li>
                        <li>
                          <a href="rooms.html">Rooms</a>
                        </li>
                        <li>
                          <a href="about.html">About</a>
                        </li>
                        <li>
                          <a href="events.html">Events</a>
                        </li>
                        <li>
                          <a href="contact.html">Contact</a>
                        </li>
                        <li>
                          <a href="reservation.html">Reservation</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
